import { useHotelCardRating } from "@website/accommodation-ui/hotel-card-new/hotel-card-info/hotel-card-rating/hotel-card-rating.hook";
import { HotelCardRatingPropertiesType } from "@website/accommodation-ui/hotel-card-new/hotel-card-info/hotel-card-rating/hotel-card-rating.types";
import { MaterialIcon } from "@website/icons/material";
import { MiniChips } from "@website/ui/mini-chips";
import { isChannel } from "@website/utils/channel/helpers";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { FC, memo } from "react";

const Component: FC<HotelCardRatingPropertiesType> = (properties) => {
  const router = useRouter();
  const { size, isSuggestedCard, hasIcon = true, id, propertyId } = properties;
  const { shouldRender, reviewCount, badgeColor, badgeText, labelText } =
    useHotelCardRating(properties);

  return shouldRender ? (
    <span
      className={`flex items-center ${
        reviewCount && reviewCount?.toString().length > 5 ? "!gap-0" : "!gap-1"
      }`}
    >
      <div className="flex items-center justify-start gap-1">
        <MiniChips
          StartIcon={
            hasIcon ? (
              <MaterialIcon className="text-base" name="stars" />
            ) : undefined
          }
          color={badgeColor}
          size={size === "xSmall" ? "small" : "medium"}
          text={numberConvert(badgeText, { locale: router.locale || "fa" })}
          variant="accent"
        />
        {labelText && (
          <MiniChips
            className="!px-0"
            color={badgeColor}
            size={size === "xSmall" ? "small" : "medium"}
            text={labelText}
            variant="text"
          />
        )}
      </div>

      {size !== "xSmall" && reviewCount !== 0 && !isSuggestedCard && (
        <span
          className={`text-caption whitespace-nowrap ${
            size === "small"
              ? "text-on-surface-medium-emphasis"
              : "text-secondary cursor-pointer"
          }`}
          onClick={
            size === "small"
              ? undefined
              : (event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  if (isChannel(["snapp-ir"])) return;
                  return router.replace(
                    {
                      pathname: router?.pathname,
                      query: {
                        ...router?.query,
                        modal: "review",
                        selectedHotelId: ["villa"].includes(
                          process.env.NEXT_PUBLIC_APP_NAME ?? ""
                        )
                          ? propertyId
                          : id
                      }
                    },
                    undefined,
                    { shallow: true, scroll: false }
                  );
                }
          }
        >
          {`(${numberConvert(reviewCount, { locale: router.locale })} نظر)`}
        </span>
      )}
    </span>
  ) : null;
};

export const HotelCardRating = memo(Component, deepCompare);
